import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { AppGlobalActions } from '@app/_store/actions/global.actions';
import { selectUserInfo } from '@app/_store/features/user-info/user-info.selectors';
import { selectIsNeedToShowBlockedPaywall } from '@app/_store/features/user-plan/user-plan.selectors';
import { AuthService } from '@core/services/auth.service';
import { Store } from '@ngrx/store';
import { map } from 'rxjs';

export const BlockedPaywallGuard: CanActivateFn | CanActivateChildFn = (
  { queryParams },
  { url }
) => {
  const router = inject(Router);
  const store = inject(Store);
  const auth = inject(AuthService);
  // A visitor without a session used to trigger `loadAppDataIfNeeded` — one
  // unsigned `/sync/fetchData` — before being sent to sign-in (QA audit #2, A19).
  return auth.isAuthenticated().pipe(
    map((token) => {
      if (!token) return router.createUrlTree(['/sign-in'], { queryParams });

      const show = store.selectSignal(selectIsNeedToShowBlockedPaywall);
      const userInfo = store.selectSignal(selectUserInfo);
      const isBlockedPaywall = url.startsWith('/blocked');

      if (!userInfo()) {
        store.dispatch(AppGlobalActions.loadAppDataIfNeeded());
      }

      if (show()) {
        return isBlockedPaywall
          ? true
          : router.createUrlTree(['/blocked'], { queryParams });
      }
      return isBlockedPaywall ? router.createUrlTree(['/']) : true;
    })
  );
};
